<template>
  <el-dialog
    :title="'商户测试 - ' + nickname"
    :visible="visible"
    width="720px"
    append-to-body
    :destroy-on-close="true"
    :lock-scroll="false"
    custom-class="ele-dialog-form"
    @update:visible="updateVisible"
    @opened="handleOpened">
    <el-tabs v-model="activeTab" @tab-click="handleTabChange">
      <el-tab-pane label="代收" name="in" />
      <el-tab-pane label="代付" name="out" />
    </el-tabs>
    <el-form ref="form" :model="form" :rules="rules" label-width="100px" class="user-test-form">
      <el-form-item label="测试通道:" prop="channelId">
        <el-select
          v-model="form.channelId"
          filterable
          clearable
          placeholder="请选择"
          class="ele-block"
          :loading="channelLoading"
          popper-append-to-body>
          <el-option
            v-for="item in channelOptions"
            :key="item.id"
            :label="item.label"
            :value="item.id" />
        </el-select>
      </el-form-item>
      <el-form-item label="测试金额:" prop="amount">
        <el-input v-model="form.amount" clearable placeholder="请输入">
          <template slot="suffix">元</template>
        </el-input>
      </el-form-item>
      <template v-if="activeTab === 'out'">
        <el-form-item label="收款姓名:" prop="payerName">
          <el-input v-model="form.payerName" clearable placeholder="请输入" />
        </el-form-item>
        <el-form-item label="收款账号:" prop="payerAccount">
          <el-input v-model="form.payerAccount" clearable placeholder="请输入" />
        </el-form-item>
        <el-form-item label="银行编码:" prop="bankCode">
          <el-select
            v-model="form.bankCode"
            filterable
            clearable
            placeholder="请选择"
            class="ele-block"
            popper-append-to-body>
            <el-option
              v-for="item in banks"
              :key="item.bank_code || item.id"
              :label="item.label"
              :value="item.bank_code" />
          </el-select>
        </el-form-item>
      </template>
    </el-form>
    <el-form v-if="hasResult" size="mini" label-width="100px" class="ele-form-detail">
      <el-form-item label="请求参数:">
        <div class="ele-text-secondary">{{ formatJson(resultRequest) }}</div>
      </el-form-item>
      <el-form-item label="响应:">
        <div class="ele-text-secondary">{{ formatJson(resultResponse) }}</div>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="updateVisible(false)">取消</el-button>
      <el-button type="primary" :loading="submitting" @click="submitTest">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
const defaultForm = () => ({
  channelId: '',
  amount: '100',
  payerName: '测试',
  payerAccount: '6222021234567890123',
  bankCode: ''
});

export default {
  name: 'UserTestDialog',
  props: {
    visible: Boolean,
    user: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      activeTab: 'in',
      form: defaultForm(),
      rules: {
        channelId: [{ required: true, message: '请选择', trigger: 'change' }],
        amount: [{ required: true, message: '请输入', trigger: 'blur' }],
        payerName: [{ required: true, message: '请输入', trigger: 'blur' }],
        payerAccount: [{ required: true, message: '请输入', trigger: 'blur' }],
        bankCode: [{ required: true, message: '请选择', trigger: 'change' }]
      },
      collectionChannels: [],
      paymentChannels: [],
      banks: [],
      channelLoading: false,
      submitting: false,
      resultRequest: null,
      resultResponse: null
    };
  },
  computed: {
    nickname() {
      if (!this.user) {
        return '';
      }
      return this.user.realname || this.user.username;
    },
    channelOptions() {
      return this.activeTab === 'out' ? this.paymentChannels : this.collectionChannels;
    },
    hasResult() {
      return this.resultRequest != null || this.resultResponse != null;
    }
  },
  methods: {
    updateVisible(val) {
      this.$emit('update:visible', val);
    },
    clearResult() {
      this.resultRequest = null;
      this.resultResponse = null;
    },
    formatJson(value) {
      if (value == null || value === '') {
        return '';
      }
      if (typeof value === 'string') {
        return value;
      }
      try {
        return JSON.stringify(value, null, 2);
      } catch (e) {
        return String(value);
      }
    },
    formatChannelLabel(item) {
      const typeName = item.channel_name;
      const name = item.name;
      const code = item.channel_code;
      if (typeName && name) {
        return code ? `${typeName} / ${name} (${code})` : `${typeName} / ${name}`;
      }
      return name || code || String(item.id);
    },
    handleOpened() {
      this.activeTab = 'in';
      this.form = defaultForm();
      this.clearResult();
      this.loadChannels();
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.clearValidate();
      });
    },
    handleTabChange() {
      this.form.channelId = '';
      this.clearResult();
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.clearValidate();
      });
    },
    loadChannels() {
      if (!this.user || !this.user.id) {
        return;
      }
      this.channelLoading = true;
      this.$http
        .get('/Test/getTestChannels', {
          params: { user_id: this.user.id }
        })
        .then((res) => {
          this.channelLoading = false;
          if (res.data.code !== 0) {
            this.$message.error(res.data.msg || '加载通道失败');
            return;
          }
          const data = res.data.data || {};
          this.collectionChannels = (data.collection || []).map((item) => ({
            ...item,
            id: Number(item.id),
            label: this.formatChannelLabel(item)
          }));
          this.paymentChannels = (data.payment || []).map((item) => ({
            ...item,
            id: Number(item.id),
            label: this.formatChannelLabel(item)
          }));
          this.banks = (data.banks || []).map((item) => ({
            ...item,
            label: `${item.bank_name} (${item.bank_code})`
          }));
          if (this.banks.length && !this.form.bankCode) {
            this.form.bankCode = this.banks[0].bank_code;
          }
        })
        .catch((e) => {
          this.channelLoading = false;
          this.$message.error(e.message);
        });
    },
    submitTest() {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        const selected = this.channelOptions.find((item) => item.id === this.form.channelId);
        if (!selected) {
          this.$message.warning('请选择');
          return;
        }
        const isOut = this.activeTab === 'out';
        const payload = {
          user_id: this.user.id,
          PaymentAmount: this.form.amount,
          channel_code: selected.channel_code
        };
        if (isOut) {
          payload.PayerName = this.form.payerName;
          payload.PayerAccount = this.form.payerAccount;
          payload.PayerBankName = this.form.bankCode;
        }
        this.submitting = true;
        this.clearResult();
        this.$http
          .post(isOut ? '/Test/testPayment' : '/Test/testCollection', payload)
          .then((res) => {
            this.submitting = false;
            const data = (res.data && res.data.data) || {};
            this.resultRequest = data.request != null ? data.request : null;
            this.resultResponse = data.response != null ? data.response : res.data;
            if (res.data.code === 0) {
              this.$message.success(res.data.msg || '请求完成');
            } else {
              this.$message.warning(res.data.msg || '请求失败');
            }
          })
          .catch((e) => {
            this.submitting = false;
            this.$message.error(e.message);
          });
      });
    }
  }
};
</script>

<style scoped>
/* ele-admin 将 .el-tabs__header margin 置 0，这里补回与表单的间距 */
.user-test-form {
  margin-top: 18px;
}
</style>
